module.exports = __webpack_public_path__ + "static/img/mnjs.3e5b9838.png";